import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  className?: string;
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  align = 'left',
  className = '',
  light = false
}: SectionHeadingProps) {
  return <div className={`flex flex-col ${align === 'center' ? 'items-center text-center' : 'items-start text-left'} ${className}`} data-id="element-180">
      {subtitle && <span className={`text-sm font-semibold tracking-wider uppercase mb-3 ${light ? 'text-accent' : 'text-accent'}`} data-id="element-181">
          {subtitle}
        </span>}
      <h2 className={`text-3xl md:text-4xl lg:text-5xl font-light tracking-tight ${light ? 'text-white' : 'text-charcoal'}`} data-id="element-182">
        {title}
      </h2>
      <div className={`h-1 w-12 mt-6 ${light ? 'bg-accent' : 'bg-accent'}`} data-id="element-183" />
    </div>;
}